module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_nsouls.00b53190b2c900046839ca30e1624360.png";